import PropTypes from "prop-types";

const propTypes = {
  canSelectAll: PropTypes.bool,
  canClearAll: PropTypes.bool,
  isSelectNoneChecked: PropTypes.bool,
  handleSelectAll: PropTypes.func,
  handleSelectNone: PropTypes.func,
  handleClearAll: PropTypes.func,
};

const HappinessSurveyCheckbox = ({
  canSelectAll = true,
  canClearAll = true,
  isSelectNoneChecked = false,
  handleSelectAll,
  handleClearAll,
  handleSelectNone,
}) => {
  const renderSelectNone = () => {
    return (
      <div className={`w-6 h-6`}>
        {isSelectNoneChecked ? (
          <svg
            data-test-id="select-none-checked"
            className="text-onyx"
            fill="none"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <rect stroke="currentColor" x="0.75" y="0.75" width="22.5" height="22.5" strokeWidth="1.5" />
            <path
              stroke="currentColor"
              d="M6 13.186L10.2439 18L18 6"
              strokeWidth="2.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            className="text-onyx"
            data-test-id="select-none-unchecked"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect stroke="currentColor" x="0.75" y="0.75" width="22.5" height="22.5" strokeWidth="1.5" />
          </svg>
        )}
      </div>
    );
  };

  const inputs = (
    <div className="flex justify-between items-center gap-6">
      <label
        data-test-id="happiness-survey-checkbox-select-none"
        className="flex items-center gap-2 cursor-pointer normal-case tracking-normal leading-normal mb-4">
        <input
          type="checkbox"
          className="pointer-events-none"
          checked={isSelectNoneChecked}
          onChange={handleSelectNone}
        />
        {renderSelectNone()}
        <span>I didn’t wear any</span>
      </label>
      <div className="flex items-center gap-2 font-semibold">
        <button
          className={`text-onyx cursor-pointer mb-4 ${!canSelectAll ? "opacity-50 pointer-events-none" : ""}`}
          onClick={handleSelectAll}
          disabled={!canSelectAll}
          data-test-id="happiness-survey-checkbox-select-all">
          Select All
        </button>
        <span className="mb-4">|</span>
        <button
          className={`text-onyx cursor-pointer mb-4 ${!canClearAll ? "opacity-50 pointer-events-none" : ""}`}
          onClick={handleClearAll}
          disabled={!canClearAll}
          data-test-id="happiness-survey-checkbox-clear-all">
          Clear
        </button>
      </div>
    </div>
  );
  return inputs;
};

HappinessSurveyCheckbox.propTypes = propTypes;
export default HappinessSurveyCheckbox;
